import { render, staticRenderFns } from "./EvaluationSkillFilePage.vue?vue&type=template&id=fd4b6d24&"
import script from "./EvaluationSkillFilePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationSkillFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports